import ajax from 'iss/utils/ajax';

const refetchInterval = 5 * ajax.MINUTES;

export const observeFinishedEvents = createUrlMonitor("/count/finished-events");
export const observeNewActivations = createUrlMonitor("/count/new-activations");
export const observePersonEvaluations = createUrlMonitor("/count/person-evaluations");
export const observeSecurityObservations = createUrlMonitor("/count/security-observations");
export const observeWorkQuotes = createUrlMonitor("/count/work-quotes");
export const observeAllActivations = createUrlMonitor("/count/activations");

/** Returns an observable that fetches the given url
 * with a one minute given interval
 */
function createUrlMonitor(url) {
  return ajax.monitorUrl(url, refetchInterval, {showLoadingScreen: false});
}



// WEBPACK FOOTER //
// ./modules/issFrontend/service/StatisticsService.js